import angular from 'angular';
import Vue from 'vue';
import 'ngVue';

import EcommerceDashboard from './EcommerceDashboard.vue';

export default angular
  .module('directives.ecommercedashboard', [])
  .directive('dcEcommerceDashboard', [
    'createVueComponent',
    function (createVueComponent) {
      return createVueComponent(Vue.component('DcEcommerceDashboard', EcommerceDashboard));
    }
  ]);
